/**
 * Paula's Choice Navigation JavaScript
 * Handles mobile menu open/close, submenu navigation, and interactions
 */

(function() {
  'use strict';

  // DOM Elements
  const mobileToggle = document.querySelector('.pc--navigation-mobile-toggle');
  const mobileMenu = document.querySelector('.pc--navigation-mobile-menu');
  const overlay = document.querySelector('.pc--navigation-overlay');
  const mobileNavLinks = document.querySelectorAll('.pc--navigation-mobile-nav-link[data-has-submenu]');
  const mobileBackBtns = document.querySelectorAll('.pc--navigation-mobile-back');
  const mobileExpertBtn = document.querySelector('.pc--navigation-mobile-expert-btn');
  const body = document.body;

  // Toggle Mobile Menu (hamburger acts as both open and close)
  function toggleMobileMenu() {
    if (mobileMenu) {
      var isOpen = mobileMenu.classList.contains('active');
      if (isOpen) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    }
  }

  // Open Mobile Menu
  function openMobileMenu() {
    if (mobileMenu) {
      mobileMenu.classList.add('active');
      mobileToggle && mobileToggle.classList.add('active');
      body.classList.add('pc--navigation-menu-open');
    }
  }

  // Close Mobile Menu
  function closeMobileMenu() {
    if (mobileMenu) {
      mobileMenu.classList.remove('active');
      mobileToggle && mobileToggle.classList.remove('active');
      body.classList.remove('pc--navigation-menu-open');

      // Close all submenus
      const activeSubmenus = document.querySelectorAll('.pc--navigation-mobile-submenu.active');
      activeSubmenus.forEach(function(submenu) {
        submenu.classList.remove('active');
      });
    }
  }

  // Open Submenu
  function openSubmenu(submenuId) {
    const submenu = document.querySelector('[data-submenu="' + submenuId + '"]');
    if (submenu) {
      submenu.classList.add('active');
    }
  }

  // Close Submenu
  function closeSubmenu(submenu) {
    if (submenu) {
      submenu.classList.remove('active');
    }
  }

  // Toggle Mobile Expert Guidance
  function toggleMobileExpert() {
    if (mobileExpertBtn) {
      mobileExpertBtn.classList.toggle('active');
      const content = document.querySelector('.pc--navigation-mobile-expert-content');
      if (content) {
        content.classList.toggle('active');
      }
    }
  }

  // Event Listeners
  if (mobileToggle) {
    mobileToggle.addEventListener('click', toggleMobileMenu);
  }

  if (overlay) {
    overlay.addEventListener('click', closeMobileMenu);
  }

  // Mobile Nav Links with Submenus
  mobileNavLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const submenuId = this.getAttribute('data-submenu-target');
      if (submenuId) {
        openSubmenu(submenuId);
      }
    });
  });

  // Mobile Back Buttons
  mobileBackBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const submenu = this.closest('.pc--navigation-mobile-submenu');
      closeSubmenu(submenu);
    });
  });

  // Mobile Expert Button
  if (mobileExpertBtn) {
    mobileExpertBtn.addEventListener('click', toggleMobileExpert);
  }

  // Desktop Expert Button (Click Toggle)
  const desktopExpertWrapper = document.querySelector('.pc--navigation-expert-wrapper');
  const desktopExpertBtn = document.querySelector('.pc--navigation-expert-wrapper .pc--navigation-expert-btn');

  if (desktopExpertBtn && desktopExpertWrapper) {
    desktopExpertBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      desktopExpertWrapper.classList.toggle('active');
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function(e) {
      if (!desktopExpertWrapper.contains(e.target)) {
        desktopExpertWrapper.classList.remove('active');
      }
    });
  }

  // Desktop Dropdown Hover (for keyboard accessibility) and positioning
  const menuItems = document.querySelectorAll('.pc--navigation-menu-item');
  const navElement = document.querySelector('.pc--navigation-nav');

  function positionDropdown(dropdown) {
    if (navElement && dropdown) {
      const navRect = navElement.getBoundingClientRect();
      dropdown.style.top = navRect.bottom + 'px';
    }
  }

  function positionAllDropdowns() {
    menuItems.forEach(function(item) {
      const dropdown = item.querySelector('.pc--navigation-dropdown');
      if (dropdown) {
        positionDropdown(dropdown);
      }
    });
  }

  // Position all dropdowns immediately on load
  positionAllDropdowns();

  // Mark JS as loaded AFTER dropdowns are positioned - enables dropdown hover in CSS
  document.documentElement.classList.add('pc--js-loaded');

  // Reposition dropdowns on window resize
  window.addEventListener('resize', function() {
    positionAllDropdowns();
  });

  menuItems.forEach(function(item) {
    const link = item.querySelector('.pc--navigation-menu-link');
    const dropdown = item.querySelector('.pc--navigation-dropdown');

    if (link && dropdown) {
      // Position dropdown on hover
      item.addEventListener('mouseenter', function() {
        positionDropdown(dropdown);
      });

      link.addEventListener('focus', function() {
        positionDropdown(dropdown);
        dropdown.style.opacity = '1';
        dropdown.style.visibility = 'visible';
      });

      item.addEventListener('focusout', function(e) {
        if (!item.contains(e.relatedTarget)) {
          dropdown.style.opacity = '';
          dropdown.style.visibility = '';
        }
      });
    }
  });

  // Reposition dropdowns on scroll (keep visible while cursor is in area)
  window.addEventListener('scroll', function() {
    positionAllDropdowns();
  }, { passive: true });

  // Close mobile menu on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeMobileMenu();
    }
  });

  // Close mobile menu on window resize (if larger than mobile breakpoint)
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      if (window.innerWidth > 768 && mobileMenu && mobileMenu.classList.contains('active')) {
        closeMobileMenu();
      }
    }, 250);
  });

  // Collections Slider (Swiper) - supports multiple instances (desktop & mobile)
  var collectionSwipers = {};

  function initCollectionSlider(containerId) {
    var sliderContainer = document.querySelector('#' + containerId);
    if (!sliderContainer || typeof Swiper === 'undefined') return;

    var wrapper = sliderContainer.closest('.pc--navigation-collection-slider');
    if (!wrapper) return;

    var progressBar = wrapper.querySelector('.pc--navigation-slider-progress-bar');
    var prevBtn = wrapper.querySelector('.pc--navigation-slider-prev');
    var nextBtn = wrapper.querySelector('.pc--navigation-slider-next');

    collectionSwipers[containerId] = new Swiper('#' + containerId, {
      slidesPerView: 1.3,
      spaceBetween: 30,
      speed: 400,
      allowTouchMove: true,
      grabCursor: true,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      on: {
        init: function() {
          updateProgress(this);
          updateButtons(this);
        },
        slideChange: function() {
          updateProgress(this);
          updateButtons(this);
        }
      }
    });

    function updateProgress(swiper) {
      if (progressBar) {
        var progress = (swiper.activeIndex + 1) / swiper.slides.length;
        progressBar.style.width = (progress * 100) + '%';
      }
    }

    function updateButtons(swiper) {
      if (prevBtn) {
        prevBtn.disabled = swiper.isBeginning;
        prevBtn.style.opacity = swiper.isBeginning ? '0.3' : '1';
      }
      if (nextBtn) {
        nextBtn.disabled = swiper.isEnd;
        nextBtn.style.opacity = swiper.isEnd ? '0.3' : '1';
      }
    }
  }

  function initAllCollectionSliders() {
    initCollectionSlider('collectionNavSwiper-desktop');
    initCollectionSlider('collectionNavSwiper-mobile');
  }

  // Update desktop swiper when Collections dropdown becomes visible
  var collectionsDropdown = document.querySelector('.pc--navigation-dropdown--collections');
  if (collectionsDropdown) {
    var collectionsMenuItem = collectionsDropdown.closest('.pc--navigation-menu-item');
    if (collectionsMenuItem) {
      collectionsMenuItem.addEventListener('mouseenter', function() {
        setTimeout(function() {
          if (collectionSwipers['collectionNavSwiper-desktop']) {
            collectionSwipers['collectionNavSwiper-desktop'].update();
          }
        }, 100);
      });
    }
  }

  // Update mobile swiper when Collections submenu becomes visible
  var collectionsSubmenu = document.querySelector('[data-submenu="collections"]');
  if (collectionsSubmenu) {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.target.classList.contains('active')) {
          setTimeout(function() {
            if (collectionSwipers['collectionNavSwiper-mobile']) {
              collectionSwipers['collectionNavSwiper-mobile'].update();
            }
          }, 100);
        }
      });
    });
    observer.observe(collectionsSubmenu, { attributes: true, attributeFilter: ['class'] });
  }

  // Initialize sliders when ready
  function tryInitSliders() {
    if (typeof Swiper !== 'undefined') {
      initAllCollectionSliders();
    } else {
      setTimeout(tryInitSliders, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInitSliders);
  } else {
    tryInitSliders();
  }

})();
